'use strict';

var _asyncToGenerator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _wrapAsyncGenerator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncGeneratorDelegate");

var errCode = require('err-code');

var browserStreamToIt = require('browser-readablestream-to-it');

var itPeekable = require('it-peekable');

var map = require('it-map');

var _require = require('./utils'),
    isBytes = _require.isBytes,
    isBlob = _require.isBlob,
    isFileObject = _require.isFileObject;

module.exports =
/*#__PURE__*/
function () {
  var _normaliseInput = _wrapAsyncGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(input, normaliseContent) {
    var peekable, _ref, value, done;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(input === null || input === undefined)) {
              _context.next = 2;
              break;
            }

            throw errCode(new Error("Unexpected input: ".concat(input)), 'ERR_UNEXPECTED_INPUT');

          case 2:
            if (!(typeof input === 'string' || input instanceof String)) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return toFileObject(input, normaliseContent);

          case 5:
            return _context.abrupt("return");

          case 6:
            if (!(isBytes(input) || isBlob(input))) {
              _context.next = 10;
              break;
            }

            _context.next = 9;
            return toFileObject(input, normaliseContent);

          case 9:
            return _context.abrupt("return");

          case 10:
            // Browser ReadableStream
            if (typeof input.getReader === 'function') {
              input = browserStreamToIt(input);
            } // Iterable<?>


            if (!(input[Symbol.iterator] || input[Symbol.asyncIterator])) {
              _context.next = 32;
              break;
            }

            peekable = itPeekable(input);
            _context.next = 15;
            return _awaitAsyncGenerator(peekable.peek());

          case 15:
            _ref = _context.sent;
            value = _ref.value;
            done = _ref.done;

            if (!done) {
              _context.next = 21;
              break;
            }

            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(peekable), _awaitAsyncGenerator), "t0", 20);

          case 20:
            return _context.abrupt("return");

          case 21:
            peekable.push(value); // (Async)Iterable<Number>
            // (Async)Iterable<Bytes>

            if (!(Number.isInteger(value) || isBytes(value))) {
              _context.next = 26;
              break;
            }

            _context.next = 25;
            return toFileObject(peekable, normaliseContent);

          case 25:
            return _context.abrupt("return");

          case 26:
            if (!(isFileObject(value) || isBlob(value) || typeof value === 'string' || value instanceof String)) {
              _context.next = 29;
              break;
            }

            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(map(peekable, function (value) {
              return toFileObject(value, normaliseContent);
            })), _awaitAsyncGenerator), "t1", 28);

          case 28:
            return _context.abrupt("return");

          case 29:
            if (!(value[Symbol.iterator] || value[Symbol.asyncIterator] || typeof value.getReader === 'function')) {
              _context.next = 32;
              break;
            }

            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(map(peekable, function (value) {
              return toFileObject(value, normaliseContent);
            })), _awaitAsyncGenerator), "t2", 31);

          case 31:
            return _context.abrupt("return");

          case 32:
            if (!isFileObject(input)) {
              _context.next = 36;
              break;
            }

            _context.next = 35;
            return toFileObject(input, normaliseContent);

          case 35:
            return _context.abrupt("return");

          case 36:
            throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 37:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  function normaliseInput(_x, _x2) {
    return _normaliseInput.apply(this, arguments);
  }

  return normaliseInput;
}();

function toFileObject(_x3, _x4) {
  return _toFileObject.apply(this, arguments);
}

function _toFileObject() {
  _toFileObject = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(input, normaliseContent) {
    var obj;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            obj = {
              path: input.path || '',
              mode: input.mode,
              mtime: input.mtime
            };

            if (!input.content) {
              _context2.next = 7;
              break;
            }

            _context2.next = 4;
            return normaliseContent(input.content);

          case 4:
            obj.content = _context2.sent;
            _context2.next = 11;
            break;

          case 7:
            if (input.path) {
              _context2.next = 11;
              break;
            }

            _context2.next = 10;
            return normaliseContent(input);

          case 10:
            obj.content = _context2.sent;

          case 11:
            return _context2.abrupt("return", obj);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _toFileObject.apply(this, arguments);
}